import { createSelector } from '@reduxjs/toolkit'
import { LoadingStatus } from 'shared/types'
import type { RootState } from 'app'

const getPaymentsState = (state: RootState) => state.common.payments

export const getPaymentMethodsState = createSelector(
  getPaymentsState,
  state => state.paymentMethods
)

export const getAvailablePackagesState = createSelector(
  getPaymentsState,
  state => state.packages
)

export const getAdministrativePaymentProductState = createSelector(
  getPaymentsState,
  state => state.administrativePaymentProduct
)

export const getAvailableSubscriptionsState = createSelector(
  getPaymentsState,
  state => state.subscriptions
)

export const getSelectedProduct = createSelector(
  getPaymentsState,
  state => state.selectedProduct
)

export const getCartState = createSelector(
  getPaymentsState,
  state => state.cart
)

export const getSummaryFormValeus = createSelector(
  getPaymentsState,
  state => state.summaryFormValues
)

export const getMonthlyRemindersAmount = createSelector(
  getAvailableSubscriptionsState,
  ({ data }) => {
    const [subscription] = data

    return subscription?.smsCount || 0
  }
)

export const getApplyPromoCodeState = createSelector(
  getPaymentsState,
  state => state.applyPromoCode
)

export const getRemovePromoCodeState = createSelector(
  getPaymentsState,
  state => state.removePromoCode
)

export const getCreateOrderState = createSelector(
  getPaymentsState,
  state => state.createOrder
)

export const getIsPaymentStepLoading = createSelector(
  getCreateOrderState,
  getApplyPromoCodeState,
  getRemovePromoCodeState,
  (
    { loading: createOrderLoading },
    { loading: applyPromoCodeLoading },
    { loading: removePromoCodeLoading }
  ) =>
    [
      removePromoCodeLoading,
      applyPromoCodeLoading,
      createOrderLoading,
    ].includes(LoadingStatus.Pending)
)
